import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import {
  MatLegacyDialogModule as MatDialogModule,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import {
  MatLegacyTableDataSource as MatTableDataSource,
  MatLegacyTableModule as MatTableModule,
} from '@angular/material/legacy-table';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatToolbarModule } from '@angular/material/toolbar';
import {
  BazisMaterialHelper,
  CuttingCadModelMaterialLink,
  PriceListProductBazisElement,
  ProductProcessingMode,
} from 'cloud-shared-lib';
import { ProductMaterialsLinkInfoComponent } from './product-materials-link-info/product-materials-link-info.component';

@Component({
  templateUrl: './elements-info-dialog.component.html',
  styleUrls: ['./elements-info-dialog.component.scss'],
  standalone: true,
  imports: [
    MatToolbarModule,
    MatTabsModule,
    MatIconModule,
    MatTableModule,
    MatButtonModule,
    MatDialogModule,
    MatTooltipModule,
    ProductMaterialsLinkInfoComponent,
  ],
  encapsulation: ViewEncapsulation.None,
})
export class ElementsInfoDialogComponent {
  @Input() multiplier = 1;

  @Input() productMaterialLink: CuttingCadModelMaterialLink[] = [];
  @Input() productProcessingMode = ProductProcessingMode.CuttingAndEstimate;

  displayedColumns: string[] = ['article', 'name', 'materialName', 'count'];
  dataSource: MatTableDataSource<PriceListProductBazisElement> = new MatTableDataSource([]);

  @Input() set elements(val: PriceListProductBazisElement[]) {
    this.dataSource.data = val.filter(e => e.isVisible);

    if (!this.hasArticles(val)) {
      this.displayedColumns.shift();
    }

    if (this.productProcessingMode === ProductProcessingMode.PriceList) {
      this.displayedColumns.push('price');
    }
  }

  constructor(public dialogRef: MatDialogRef<ElementsInfoDialogComponent>) {}

  hasArticles(val: PriceListProductBazisElement[]): boolean {
    const itemWithArticle = val.find(w => w.article.trim() !== '');
    return itemWithArticle !== undefined;
  }

  formatMaterialName(materialName: string): string {
    return BazisMaterialHelper.formatMaterialName(materialName, $localize`Артикул`);
  }
}
